import React from 'react';
import {NavigationDots, SocialMedia} from '../components';

//Applying Higher Order Component
const AppWrap = (Component, idName, classNames) => function HOC() {
  return (
    <div id={idName} className={`app__container ${classNames}`}>
        <SocialMedia />

        <div className='app__wrapper app__flex'>
            <Component />
            <div className='copyright'>
                <p className='p-text'>@2024 Hanhz</p>
                <p className='p-text'>All rights reserved</p>
            </div>
        </div>
        {/* To know which section are we on */}
        <NavigationDots active={idName} />
    </div>
  );
};

export default AppWrap;